import React, { createContext, useContext, useEffect, useState } from 'react';
import bonusQuestionService from '../services/bonusQuestionService';
import { useBeta } from './BetaContext';

const BonusQuestionsContext = createContext(null);

export const BonusQuestionsProvider = ({ children }) => {
  const { activePartyId } = useBeta();
  const [bonusQuestions, setBonusQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!activePartyId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const fetchBonusQuestions = async () => {
      try {
        const questions = await bonusQuestionService.fetchBonusQuestions(activePartyId);
        setBonusQuestions(questions);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching bonus questions:', err);
        setError(err.message || 'Failed to load bonus questions');
        setLoading(false);
      }
    };

    fetchBonusQuestions();
  }, [activePartyId]);

  const value = {
    bonusQuestions,
    loading,
    error,
  };

  return (
    <BonusQuestionsContext.Provider value={value}>
      {children}
    </BonusQuestionsContext.Provider>
  );
};

export const useBonusQuestions = () => {
  const context = useContext(BonusQuestionsContext);
  if (!context) {
    throw new Error('useBonusQuestions must be used within a BonusQuestionsProvider');
  }
  return context;
};
